const heading4Numbered = [
  "M6.17 15.22l.93-3.48h2.36l-.93 3.48h1.77l.93-3.48h3.24l.46-1.7h-3.25l.62-2.27h3.24l.46-1.7h-3.25l.87-3.23h-1.77L11 6.06H8.61l.88-3.22H7.72l-.86 3.22H3.6l-.46 1.7h3.25l-.6 2.28H2.54l-.45 1.7h3.25l-.94 3.48zm3.75-5.18H7.56l.6-2.27h2.37z",
  "M.7 4.5V2.96h1.67V4.5h.7V.78h-.7V2.3H.7V.78H0V4.5zm5.32 0v-.58h.33v-.66h-.33v-.93H5.3v.93h-.8L5.66.78h-.81L3.69 3.26v.66H5.3v.58z"
];
export {
  heading4Numbered
};
//# sourceMappingURL=heading4Numbered.js.map
